import { render, staticRenderFns } from "./TermsOfServiceScreen.vue?vue&type=template&id=504e6b94&scoped=true"
import script from "./TermsOfServiceScreen.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceScreen.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceScreen.vue?vue&type=style&index=0&id=504e6b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e6b94",
  null
  
)

export default component.exports